import React from "react";

const StyledBackground = ({src, style}) => <div className={'background'}
                                                style={{backgroundImage: `url('/${src}${style}')`}} aria-hidden={true}
                                                alt={''}/>;

export default StyledBackground;
